export default "__VITE_ASSET__DSRYxR4$__"